import React from 'react';
import Hero from '../../components/Hero/Hero';

import About from '../../components/About/About';
import Contact from '../../components/Contact/Contact';
import './Home.css';

const Home = () => {
  return (
    <main>
      <Hero />

      <About />
      <Contact />
    </main>
  );
};

export default Home;